import _Promise from 'babel-runtime/core-js/promise';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import AbstractTransport from '@central-products/abstract-transport-bus';
import MessageBusTransport from '@central-products/message-transport-bus';
import { publish } from '@wh/message-bus';

import IOddsFormat from './OddsFormatInterface';

import { ODDS_FORMAT_TOPICS } from '.';

var OddsFormatService = function (_IOddsFormat) {
  _inherits(OddsFormatService, _IOddsFormat);

  function OddsFormatService(transport, setCurrentOddsFormat) {
    _classCallCheck(this, OddsFormatService);

    var _this = _possibleConstructorReturn(this, (OddsFormatService.__proto__ || _Object$getPrototypeOf(OddsFormatService)).call(this));

    (transport || MessageBusTransport.getInstance()).bind(_this);
    _this.setCurrentOddsFormat = setCurrentOddsFormat;
    return _this;
  }

  _createClass(OddsFormatService, [{
    key: 'requestOddsFormatChange',
    value: function requestOddsFormatChange(format) {
      publish(ODDS_FORMAT_TOPICS.ON_ODDS_FORMAT_CHANGE, format);
    }
  }, {
    key: 'change',
    value: function change(_ref) {
      var format = _ref.payload.format;

      this.setCurrentOddsFormat(format);
      return _Promise.resolve();
    }
  }]);

  return OddsFormatService;
}(IOddsFormat);

export { OddsFormatService as default };